import { motion } from 'framer-motion';
import React from 'react';
import { FaCode, FaDatabase, FaServer} from 'react-icons/fa';
import { LuFigma } from "react-icons/lu";

const About = () => {
    return (
        <section id="about" className="about py-5">
            <div className="container">
                {/* Heading */}
                <motion.h2
                    className="text-center fw-bold mb-4"
                    initial={{ opacity: 0, y: -30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    About Me
                </motion.h2>

                {/* Intro Paragraph */}
                <motion.p
                    className="text-center lead text-white mx-auto"
                    style={{ maxWidth: '700px' }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    I’m a passionate MERN stack developer who loves turning ideas into interactive, 
                    user-friendly web applications and designs. I focus on clean UI, accessible markup, and 
                    smooth functionality, blending creativity with technical skill to deliver 
                    production-ready solutions.
                </motion.p>

                {/* Skills Grid */}
                <div className="row text-center mt-5">
                    <motion.div
                        className="col-md-3 mb-4"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <FaCode size={40} className="text-primary mb-2" />
                        <h5>Frontend</h5>
                        <p className="small about-text">React, JavaScript, TailwindCSS</p>
                    </motion.div>

                    <motion.div
                        className="col-md-3 mb-4"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <FaServer size={40} className="text-success mb-2" />
                        <h5>Backend</h5>
                        <p className="small about-text">Node.js, Express.js, Typescript</p>
                    </motion.div>

                    <motion.div
                        className="col-md-3 mb-4"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <FaDatabase size={40} className="text-warning mb-2" />
                        <h5>Database</h5>
                        <p className="small about-text">MongoDB</p>
                    </motion.div>

                    <motion.div
                        className="col-md-3 mb-4"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6, duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <LuFigma size={40} className="text-info mb-2" />
                        <h5>Web Design</h5>
                        <p className="small about-text">Figma</p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default About;
